import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { get } from 'lodash-es';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private key = 'PCTOKEN';

  get authorization(): string {
    return `${this.getToken('token_type')} ${this.getToken('access_token')}`;
  }

  constructor(private router: Router) {}

  hasToken(): boolean {
    return !!this.getToken();
  }

  getToken(...value: Array<string>): any {
    let token: any;

    try {
      const item = sessionStorage.getItem(this.key);
      token = item ? JSON.parse(item) : null;
    } catch (error) {}

    if (value.length > 0) {
      value.forEach((key) => {
        token = get(token, key, null);
      });
    }
    return token;
  }

  setToken(value: any): void {
    sessionStorage.setItem(this.key, JSON.stringify(value));
  }

  addValue(key: string, value: any): void {
    const token = this.getToken();
    token[key] = value;
    this.setToken(token);
  }

  removeTokenAndLogout(): void {
    const alias = this.getToken()['alias'];
    sessionStorage.removeItem(this.key);
    if (!this.router.url.includes('login')) {
      this.router.navigate([`/login/${alias}`]);
    }
  }

  removeToken(): void {
    sessionStorage.removeItem(this.key);
  }
}
